import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppServiceModule } from './services/app-service.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { AppEffects } from './store/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { appInitialState, appReducer } from './store/reducers';
import { AppFacade } from './store/facade';
import { AppServices } from './store/services';
import { SpinnerService } from './services/spinner.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { SnackbarService } from './services/snackbar.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppServiceModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    EffectsModule.forRoot([AppEffects]),
    StoreRouterConnectingModule.forRoot(),
    StoreModule.forRoot({ app: appReducer }, { initialState: { app: appInitialState }, runtimeChecks: {strictActionWithinNgZone: true}}),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production })
  ],
  providers: [AppFacade, AppServices, 
    SpinnerService,
    SnackbarService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
